import { UserPronoun } from '~/generated/graphql'

export function getPronoun(pronoun: UserPronoun) {
  if (pronoun === UserPronoun.She) return 'she/her'
  if (pronoun === UserPronoun.He) return 'he/him'
  if (pronoun === UserPronoun.Them) return 'they/them'
  //   else return 'Shee/herr'
}
